import SwimlaneReadyModal from './SwimlaneReadyModal';

export default SwimlaneReadyModal;
